import type {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import type {GetListResponse, ParamsOptions} from "@/src/modules/core/types";

import type {
  PatrolRoute,
  PatrolRouteListItem,
  PatrolRouteStoreRequest,
  PatrolRouteUpdateRequest,
} from "../types";

class PatrolRoutesApi extends CoreApi {
  list(options?: ParamsOptions): Promise<AxiosResponse<GetListResponse<PatrolRouteListItem>>> {
    return super.search("patrol-route", options ?? {});
  }

  show(id: number): Promise<AxiosResponse<{data: PatrolRoute}>> {
    return super.getById("patrol-route", id);
  }

  store(data: PatrolRouteStoreRequest): Promise<AxiosResponse<{data: PatrolRoute}>> {
    return super.create("patrol-route", data);
  }

  patch(id: number, data: PatrolRouteUpdateRequest): Promise<AxiosResponse<{data: PatrolRoute}>> {
    return super.update("patrol-route", id, data);
  }

  deactivate(id: number): Promise<AxiosResponse<void>> {
    return super.delete("patrol-route", id);
  }
}

export const patrolRoutesApi = new PatrolRoutesApi();
